import { Injectable } from '@angular/core';

import { AcompanhamentoPreferencias } from '../models/acompanhamento-pedagogico.types';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoPedagogicoPreferencesService {
  private readonly storageKey = 'professores.pwa.acompanhamento-pedagogico.preferences';

  save(preferencias: AcompanhamentoPreferencias): void {
    localStorage.setItem(this.storageKey, JSON.stringify(preferencias));
  }

  load(): AcompanhamentoPreferencias {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) {
        return { filtrarPublicoAlvo: false };
      }

      return JSON.parse(raw) as AcompanhamentoPreferencias;
    } catch {
      return { filtrarPublicoAlvo: false };
    }
  }
}
